import React, { FC } from "react";
import { useLocation } from "react-router";
import { ISidebarItem } from "./types";
import { Link } from "../Link";
import { TabItem } from "../TabItem";

interface Props {
  item: ISidebarItem;
  tabClassName?: string;
}

export const SidebarItem: FC<Props> = ({ item, tabClassName }) => {
  const { pathname } = useLocation();

  const isActive = pathname === item.href;

  return (
    <Link href={item.href}>
      <TabItem className={tabClassName} tab={item} isActive={isActive} />
    </Link>
  );
};
